import { createFileRoute, notFound } from "@tanstack/react-router"
import { CHARACTERS, type CharacterType } from "@/entities/characters"
import { CharacterReportPage } from "@/pages/character-report"

export const Route = createFileRoute("/_authenticated/character/$character")({
	params: {
		parse: (raw) => {
			const character = raw.character as CharacterType
			if (!CHARACTERS.includes(character)) throw notFound()
			return { character }
		},
		stringify: (parsed) => ({ character: parsed.character }),
	},
	component: CharacterReportPageWrapper,
})

function CharacterReportPageWrapper() {
	const { character } = Route.useParams()
	return <CharacterReportPage character={character} />
}
